import {
    getAssetImageUrl,
    isArchive,
    isEpisode,
    isRecording,
    isSeason,
    isSeries,
    isVod
} from 'Utils';
import { getFirstEpisode, getRecordingForItem, itemCanBePlayed } from 'Utils/itemUtils';
import { Device } from 'DeviceUtils';

export default class DetailModel {
    constructor(item, parentItem) {
        /** @type {AssetDetail} */
        this.item = item;

        this.parentItem = parentItem;
        // console.log('DetailModel', item, parentItem);
        this.isSeries = item ? isSeries(item) : false;
        this.isSeason = item ? isSeason(item) : false;
        // Asset is episode also when it has parent item, but this is not the case for season
        // Part with parentItem covers mainly tv series
        this.isEpisode = item
            ? isEpisode(item) || (Boolean(this.parentItem) && !this.isSeason)
            : false;
        this.isRecording = item ? isRecording(item) : false;
        this.isArchive = item ? isArchive(item) : false;
        this.isArchiveAvailable =
            this.isArchive && this?.item?.isArchivePlayable && this.item.isArchivePlayable();

        this.isDownloadable = this.isItemDownloadable();

        this.itemToPlay = this.getItemToPlay(this.item);
        // We have something to play and item can be played
        this.canBePlayed = Boolean(this.itemToPlay && itemCanBePlayed(this.item));

        if (this.isArchive) this.canBePlayed = this.isArchiveAvailable;
        if (this.item?.hasBlackout && this.item?.hasBlackout()) this.canBePlayed = false;

        this.episodes = this.getEpisodes(this.item);

        this.seasons = this.getSeasons(this.item);

        this.hasRecommendedCarousel = item ? isVod(item) : false;
        this.hasSeriesNavigationPicker = Boolean(this.parentItem);
        this.hasTrailer = Boolean(item?.data?.trailer);
    }

    isItemDownloadable() {
        // No downloads on web
        if (Device.isWeb) return false;

        let isDownloadable = false;
        const recording = getRecordingForItem(this.item);
        // If item is archive it should be also available on mCore
        // otherwise you can download go recording
        if (this.isArchiveAvailable) {
            isDownloadable = true;
        } else if (this.isRecording && recording && !recording.ids?.iptv) {
            isDownloadable = true;
        }

        return isDownloadable;
    }

    getItemToPlay(item) {
        if (!item) return null;
        let itemToPlay = item;

        if (isSeason(item)) {
            itemToPlay = getFirstEpisode(item.episodes);
        }

        if (isSeries(item)) {
            itemToPlay = getFirstEpisode(item.seasons[0]?.episodes);
        }

        return itemToPlay;
    }

    getEpisodes(item) {
        return item?.episodes || null;
    }

    getSeasons(item) {
        return item?.seasons || null;
    }

    getPreviewImage() {
        return getAssetImageUrl(this.item, 'PREVIEW');
    }
}
